import API from "../Common/Endpoint/serviceConstrants";
import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
export const staticApi = async () => {
  const { data = {} } = await axiosInstanceClient.get(API.staticPoints);
  return data;
};
